<template src="@/templates/reservations/invoice.html"></template>

<script>
import userApi from '@/api/userApi';
import { restEndpoint } from '@/config.json';
import userAuthStore from '@/store/userAuthStore';

export default {
  props: [
    'reservationId',
  ],
  data() {
    return {
      invoice: {},
      isLoading: true,
      token: userAuthStore.state.token,
    };
  },
  computed: {
    invoiceDownloadUrl() {
      return `${restEndpoint}/reservation/${this.reservationId}/download-invoice`;
    },
    invoiceAttachmentDownloadUrl() {
      return `${restEndpoint}/reservation/${this.reservationId}/download-invoice-attachment`;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      userApi.getInvoice(this.reservationId, (data) => {
        this.invoice = data.invoice;
        this.isLoading = false;
      });
    },
    downloadInvoice() {
      userApi.downloadInvoice(this.reservationId, this.invoice.id);
    },
    downloadInvoiceAttachment() {
      userApi.downloadInvoiceAttachment(this.reservationId);
    },
    roundUp(value) {
      if (typeof value !== 'undefined') {
        return parseFloat(value).toFixed(2);
      }
      return '';
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// invoice.vue?58db5d44